import React, { useState, useEffect } from "react";
import Logo from "../../media/logonobg.png";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListSubheader from "@mui/material/ListSubheader";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Bars3Icon } from "@heroicons/react/24/outline";

export default function SideBarAdmin() {
    const localUser = JSON.parse(localStorage.getItem("user"));
    if (!localUser.admin && localUser.admin_access < 1) {
        window.location.href = '/';
    }

    const [isOpen, setIsOpen] = useState(window.innerWidth >= 768);


    const handleDashboardAdmin = () => {
        window.location.href = "/admin";
    };

    const handleUserAdmin = () => {
        window.location.href = "/admin/users";
    };
    const handleSubscriptionAdmin = () => {
        window.location.href = "/admin/subscription";
    };
    const handleSubscriptionPricesAdmin = () => {
        window.location.href = "/admin/subscription/prices";
    };
    const handleArticlesAdmin = () => {
        window.location.href = "/admin/articles";
    };
    const handleFeedModerationAdmin = () => {
        window.location.href = "/admin/feed/moderation";
    };
    const handleReviewsAdmin = () => {
        window.location.href = "/admin/reviews";
    };
    const handlePayments = () => {
        window.location.href = "/admin/subscription/payments";
    }
    const handleOptionsAdmin = () => {
        window.location.href = "/admin/options";
    }

    const handleCse = () => {
        window.location.href = "/admin/cse";
    };

    const handleIgo = () => {
        window.location.href = "/admin/igo";
    };

    const handleIgoTheme = () => {
        window.location.href = "/admin/igo-theme";
    };

    const handleRegions = () => {
        window.location.href = "/admin/regions";
    };

    const handleLinksThematic = () => {
        window.location.href = "/admin/linksthematics";
    };
    const handleTutorials = () => {
        window.location.href = "/admin/tutorials";
    };

    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen(!open);
    };

    useEffect(() => {
        const handleResize = () => {
            setIsOpen(window.innerWidth >= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="mainsidebar mt-2">
            <button onClick={() => setIsOpen(!isOpen)} className="menuburger">
                <Bars3Icon className="h-6 w-6" />
            </button>
            <div className={`z-5 inset-y-0 left-0 transform ${isOpen ? 'translate-x-0' : '-translate-x-full w-0 overflow-hidden'} transition duration-200 ease-in-out`}>
                <List
                    sx={{ bgcolor: "#f6f4f5", width: "250px" }}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                    subheader={
                        <ListSubheader component="div" id="nested-list-subheader">
                            <img
                                src={Logo}
                                className="logo"
                                style={{ width: "220px", marginTop: "0", maxWidth: "80%", marginBottom: "15px" }}
                                alt="Logo"
                                onClick={() => {window.location.href = '/';}}
                            />
                        </ListSubheader>
                    }
                >
                    <ListItemButton className="sideMenuButton" onClick={handleDashboardAdmin}>
                        <span className="spanacc">Accueil Administration</span>
                    </ListItemButton>
                    {
                        (localUser.admin_access === 1 || localUser.super_admin === 1) && (
                            <ListItemButton className="sideMenuButton" onClick={handleUserAdmin}>
                                <span className="spanacc">Utilisateurs</span>
                            </ListItemButton>
                        )
                    }
                    {
                        (localUser.admin_access === 2 || localUser.admin_access === 3 || localUser.super_admin === 1) && (
                        <>
                        <ListItemButton className="sideMenuButton" onClick={handleClick}>
                            <span className="spanacc">Abonnement</span>
                            {open ? <ExpandLess /> : <ExpandMore />}
                        </ListItemButton>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {
                                    (localUser.admin_access === 3 || localUser.super_admin === 1) && (
                                        <ListItemButton className="sideMenuButton" sx={{ pl: 4 }} onClick={handleSubscriptionAdmin}>
                                            <span className="spanacc">Utilisateurs abonnés</span>
                                        </ListItemButton>
                                    )
                                }
                                {
                                    (localUser.admin_access === 2 || localUser.super_admin === 1) && (
                                        <ListItemButton className="sideMenuButton" sx={{ pl: 4 }} onClick={handlePayments}>
                                            <span className="spanacc">Historique des paiements</span>
                                        </ListItemButton>
                                    )
                                }
                                {
                                    (localUser.super_admin === 1) && (
                                        <ListItemButton className="sideMenuButton" sx={{ pl: 4 }} onClick={handleSubscriptionPricesAdmin}>
                                            <span className="spanacc">Tarifs</span>
                                        </ListItemButton>
                                    )
                                }
                                {
                                    (localUser.admin_access === 2 || localUser.super_admin === 1) && (
                                        <ListItemButton className="sideMenuButton" sx={{ pl: 4 }} onClick={() => { window.location.href = "/admin/ai-token-prices"; }}>
                                            <span className="spanacc">Tarifs tokens IA</span>
                                        </ListItemButton>
                                    )
                                }
                            </List>
                        </Collapse>
                        </>
                        )
                    }
                    {
                        (localUser.admin === 1) && (
                            <ListItemButton className="sideMenuButton" onClick={handleArticlesAdmin}>
                                <span className="spanacc">Articles</span>
                            </ListItemButton>
                        )
                    }
                    {
                        (localUser.admin === 1) && (
                            <ListItemButton className="sideMenuButton" onClick={handleFeedModerationAdmin}>
                                <span className="spanacc">Signalements du fil</span>
                            </ListItemButton>
                        )
                    }
                    {
                        (localUser.admin === 1) && (
                            <ListItemButton className="sideMenuButton" onClick={handleReviewsAdmin}>
                                <span className="spanacc">Revues de presse</span>
                            </ListItemButton>
                        )
                    }
                    {
                        (localUser.admin_access === 4 || localUser.super_admin === 1) && (
                            <ListItemButton className="sideMenuButton" onClick={handleCse}>
                                <span className="spanacc">CSE</span>
                            </ListItemButton>
                        )
                    }
                    {
                        (localUser.admin_access === 5 || localUser.super_admin === 1) && (
                            <ListItemButton className="sideMenuButton" onClick={handleIgo}>
                                <span className="spanacc">Forum global</span>
                            </ListItemButton>
                        )
                    }
                    {
                        (localUser.admin_access === 5 || localUser.super_admin === 1) && (
                            <ListItemButton className="sideMenuButton" onClick={handleIgoTheme}>
                                <span className="spanacc">Thèmes des Forums Globaux</span>
                            </ListItemButton>
                        )
                    }
                    {
                        (localUser.admin_access === 5 || localUser.super_admin === 1) && (
                            <ListItemButton className="sideMenuButton" onClick={handleRegions}>
                                <span className="spanacc">Régions</span>
                            </ListItemButton>
                        )
                    }
                    {
                        (localUser.admin_access === 6 || localUser.super_admin === 1) && (
                            <ListItemButton className="sideMenuButton" onClick={() => { window.location.href = "/admin/thematics-tree" }}>
                                <span className="spanacc">Arbre des thématiques</span>
                            </ListItemButton>
                        )
                    }
                    {
                        (localUser.admin_access === 6 || localUser.super_admin === 1) && (
                            <ListItemButton className="sideMenuButton" onClick={handleLinksThematic}>
                                <span className="spanacc">Liens thématiques</span>
                            </ListItemButton>
                        )
                    }
                    {
                        (localUser.admin_access === 7 || localUser.super_admin === 1) && (
                            <ListItemButton className="sideMenuButton" onClick={handleTutorials}>
                                <span className="spanacc">Tutoriels</span>
                            </ListItemButton>
                        )
                    }
                    {
                        (localUser.super_admin === 1) && 
                            <ListItemButton className="sideMenuButton" onClick={handleOptionsAdmin}>
                                <span className="spanacc">Options</span>
                            </ListItemButton>
                    }        
                </List>
            </div>
        </div>
    );
}
